import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { getConfig, update } from '../../api/config';
import { list } from '../../api/models';
import { Button } from '../../components/Button';
import { ModelItem } from '../../components/ModelItem';
import { SpinnerBlock } from '../../components/Spinner';
import { ModelsDetailsModal } from './ModelsDetailsModal';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './models.styl';
var ModelsView = /** @class */ (function (_super) {
    __extends(ModelsView, _super);
    function ModelsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            models: [],
            loading: false,
            showCreateModal: false,
            titleError: false,
            contentError: false,
            contentState: '',
        };
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.createAction = function () {
            _this.setState({
                editModel: undefined,
                showCreateModal: true,
            });
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (model) {
            _this.setState({
                editModel: model,
                showCreateModal: true,
            });
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleError: false });
            }
        };
        return _this;
    }
    ModelsView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    ModelsView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleError: true });
            valid = false;
        }
        var html = this.contentRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ contentError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            modelTitle: title,
            modelIntro: html,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ModelsView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        list().then(function (result) {
            _this.setState({
                loading: false,
                models: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
            });
            if (result) {
                _this.setState({
                    contentState: result.modelIntro || '',
                });
            }
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ModelsView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var i18n = props.store.i18n;
        var _a = this.state, loading = _a.loading, models = _a.models, config = _a.config, contentState = _a.contentState;
        return (React.createElement("div", { className: S.modelsView },
            React.createElement("h1", { className: S.modelsTitle }, i18n.modelsTitle),
            React.createElement("hr", { className: S.modelsSeparator }),
            React.createElement("div", { className: S.modelsMainBox },
                React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.addInputWrapper },
                            React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.addInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.modelTitle })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentRef = editor; }, apiKey: getEditorKey(), initialValue: contentState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.addButton, type: "submit", spinner: loading }, i18n.actionUpdate))),
            React.createElement("hr", { className: S.modelsSeparator }),
            React.createElement("div", { className: S.modelsHeaderActions },
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.modelsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.modelsHeader },
                            React.createElement("div", { className: S.tableCell }, i18n.modelsItemTitle),
                            React.createElement("div", { className: S.tableCell }, i18n.inputTitleColor),
                            React.createElement("div", { className: S.tableCell }, i18n.inputTitleType),
                            React.createElement("div", { className: S.action }, i18n.modelsAction)),
                        React.createElement("div", { className: S.modelsUserList }, models.map(function (model, i) { return (React.createElement(ModelItem, { key: i, model: model, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showCreateModal &&
                React.createElement(ModelsDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, model: this.state.editModel })));
    };
    __decorate([
        action.bound
    ], ModelsView.prototype, "onSubmit", null);
    ModelsView = __decorate([
        inject('store'),
        observer
    ], ModelsView);
    return ModelsView;
}(React.Component));
export { ModelsView };
